import { createContext } from "react";

export class AppSystemContextInfo {
    constructor(public systemId: string) {}
}


export const AppSystemContext = createContext(new AppSystemContextInfo(""));